import { image } from '../../../../utils/data/baseUrl';

export const Actions = {
  BACK: 'back',
  CONVERT: 'convert',
};

export const content = {
  title: 'giftConverterContent.title',
  description: 'giftConverterContent.description',
  note: {
    isAvailable: 'giftConverterContent.isAvailable',
    isUnavailable: 'giftConverterContent.notAvailable',
  },
  rules: 'Правила обмена',
  buttons: [
    {
      timeout: 2000,
      action: Actions.CONVERT,
      attr: {
        text: 'other.exchange',
        className: 'custom-button custom-button_green',
      },
    },
    {
      action: Actions.BACK,
      disposable: true,
      modalData: {
        action: 'close',
        data: { type: 'all' },
      },
      attr: {
        text: 'other.goBack',
        className: 'custom-button custom-button_gray',
      },
    },
  ],
  icons: {
    energy: {
      imgAttr: {
        src: image('reward/energy.png'),
      },
    },
    gift: {
      imgAttr: {
        src: image('reward/gift.png'),
      },
    },
    bonuses: {
      imgAttr: {
        src: image('reward/bonusesFire.png'),
      },
    },
  },
};
